/**
 * Laden, Fehler und Leerzustand der beiden lesenden Listen des Containers (REQ-27 §2.2).
 * Liegen Zeilen vor, zeichnet die aufrufende Tabelle sich selbst.
 */

import type { ReactNode } from 'react';

import { EmptyState, ErrorState, Spinner } from '@/components/ui';

import type { RelatedList } from './useRelatedList';

export interface RelatedListStateProps {
  list: RelatedList<unknown>;
  /** Text des Leerzustands. */
  emptyText: string;
  /** Font-Awesome-Angabe des Leerzustands. */
  emptyIconClass?: string;
  children: ReactNode;
}

/** Technische Einzelheit für die aufklappbaren „Details" des Fehlerzustands. */
function describeError(error: unknown): string | undefined {
  if (error instanceof Error) return error.message;
  return typeof error === 'string' ? error : undefined;
}

export function RelatedListState(props: RelatedListStateProps) {
  const { list } = props;

  if (list.loading) {
    return (
      <div className="iwm-state-loading">
        <span className="iwm-state-spinner">
          <Spinner size={20} />
        </span>
        Wird geladen …
      </div>
    );
  }

  if (list.error !== null && list.error !== undefined) {
    return (
      <ErrorState
        size="sm"
        message="Die Daten des Containers konnten nicht geladen werden."
        detail={describeError(list.error)}
        onRetry={list.retry}
      />
    );
  }

  if (list.items.length === 0) {
    return <EmptyState size="sm" title={props.emptyText} iconClass={props.emptyIconClass} />;
  }

  return props.children;
}

export default RelatedListState;
